import React, { useState } from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  Typography,
  colors,
  Box,
} from '@mui/material'
import { authedAxios } from '../../utils'
import {
  ACCOUNT_PROVIDERS,
  TASK_STATUS_TYPES,
  TASK_TYPES,
} from '../../constants'
import { useStore } from '../../store'
import useAlert from '../../hooks/useAlert'
import { addTimezoneOffsetToTimestamp } from '../../utils/date'
import { grey } from '@mui/material/colors'

const EventModal = ({
  contact,
  customer,
  isOpen,
  onCloseModal,
  onSave,
  isEditing,
}) => {
  const { state } = useStore()

  const { identity } = state

  const accountProvider = ACCOUNT_PROVIDERS.find(
    (ap) => ap.id === identity.accountProviderId
  )

  const [note, setNote] = useState('')
  const [date, setDate] = useState(new Date().toLocaleDateString('sv'))
  const [error, setError] = useState(false)

  const handleClose = () => onCloseModal()

  const createScheduleEventTask = () => {
    const task = {
      note,
      date: new Date(),
      customerContactId: contact?.id,
      taskTypeId: TASK_TYPES.SCHEDULE_EVENT,
      customerId: customer.id,
      statusTypeId: TASK_STATUS_TYPES.DONE,
    }

    return createTask(task)
  }

  const createAttendEventTask = () => {
    const task = {
      note,
      date: new Date(date),
      customerContactId: contact?.id,
      taskTypeId: TASK_TYPES.ATTEND_EVENT,
      customerId: customer.id,
      statusTypeId: TASK_STATUS_TYPES.NOT_STARTED,
    }
    return createTask(task)
  }

  const { createAlert, createGenericErrorAlert } = useAlert()

  const createTask = (task) => authedAxios.post('/api/task', task)

  const handleSubmit = () => {
    if (!date) return

    if (isEditing) {
      return onSave(TASK_TYPES.ATTEND_EVENT, TASK_STATUS_TYPES.DONE)
    }

    Promise.all([createScheduleEventTask(), createAttendEventTask()])
      .then(([schedule, attend]) => {
        onCloseModal()

        setTimeout(() => {
          createAlert({ message: 'Task created successfully' })
        }, 50)
      })
      .catch((e) => {
        setTimeout(() => {
          createGenericErrorAlert()
        }, 50)

        setError(true)
      })
  }

  const dateDisplay = addTimezoneOffsetToTimestamp(
    new Date(date)
  ).toLocaleDateString()

  return (
    <Dialog open={isOpen} onClose={handleClose} fullWidth maxWidth={'md'}>
      <DialogTitle>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          Event
          {isEditing && (
            <Button
              onClick={() => handleSubmit(TASK_STATUS_TYPES.DONE)}
              variant={'contained'}
            >
              Mark event attended
            </Button>
          )}
        </Box>
      </DialogTitle>

      <DialogContent>
        {accountProvider && (
          <Button
            sx={{ my: 2 }}
            onClick={() => window.open(accountProvider.calendarUrl, '_blank')}
            variant={'outlined'}
          >
            Take me to my calendar
          </Button>
        )}

        <TextField
          sx={{ mt: 2 }}
          label={'Change date of event'}
          type={'date'}
          margin='dense'
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          value={date}
          onChange={(e) => {
            setDate(e.target.value)
          }}
        ></TextField>
        <Typography
          sx={{ fontStyle: 'italic', fontSize: '14px', color: grey[800] }}
        >
          Use the input above to change the date.
        </Typography>

        <TextField
          onChange={(e) => setNote(e.target.value)}
          value={note}
          margin='dense'
          label={'Note'}
          fullWidth
          multiline
          rows={4}
        ></TextField>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleSubmit} color={'primary'} variant={'contained'}>
          Schedule event for {dateDisplay}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default EventModal
